import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

export default function StandstillCleaningPopup(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleChangeUser = (event) => {
        setUserName(event.target.value);
    };

    const handleChangePassword = (event) => {
        setPassword(event.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            props.action(checked, userName, password)
        }
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
        >
            <DialogTitle className={classes.dialogTitle}>
                {t("Kuisen")}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    <React.Fragment>{t("Vraag je ploegchef om de kuisprocedure te kunnen starten")}</React.Fragment>
                    <FormGroup>

                        <TextField sx={{ marginTop: '20px' }} key="supervisor-user" id="supervisor-user" disabled={checked} label={t("UsernameSuperVisor")} value={checked ? "" : userName} variant="outlined" onChange={handleChangeUser} />
                        <TextField sx={{ marginTop: '20px' }} key="supervisor-pass" id="standard-basic" disabled={checked} label={t("PasswordSuperVisor")} value={checked ? "" : password} type="password" variant="outlined" onChange={handleChangePassword} onKeyDown={(e) => handleKeyDown(e)} />
                        <FormControlLabel control={<Checkbox
                            checked={checked}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />} label={t("Ploegchef niet aanwezig")} />
                    </FormGroup>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={props.closeDialog} >
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.submitButton} disabled={!checked && (userName === "" || password === "")} autoFocus={true} onClick={() => props.action(checked, userName, password)} >
                        {t("INDIENEN")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "auto",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px",
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            color: "white",

        },

    },
    submitButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: "white",
            color: FlagstoneTheme.palette.primary.main,

        },
        margin: "3px",
        width: "100px",
        marginBottom: "20px"
    },


    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    }
}));
